import React, { useState } from 'react';
import IPLPTemplateForm, {
	IPLPTemplateFormValues,
} from '../IPLPTemplateForm/IPLPTemplateForm';
import { useCreateIplpTemplateMutation } from '../../../../../graphql/graphql';
import Loading from '../../../../../Components/Loading';
import useApiClient from '../../../../Base/Hooks/useApiClient';

interface Props {
	onCreate: () => void;
}

const IPLPTemplateCreate: React.FC<Props> = ({ onCreate }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [createIPLPTemplate] = useCreateIplpTemplateMutation();
	const { displayGQLError } = useApiClient();

	const handleSubmit = async (values: IPLPTemplateFormValues) => {
		setIsLoading(true);

		const response = await createIPLPTemplate({ input: values });
		displayGQLError(response);

		if ('data' in response) {
			onCreate();
		}

		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return <IPLPTemplateForm onSubmit={handleSubmit} />;
};

export default IPLPTemplateCreate;
